module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('download-Popup'), _vm._v(" "), _c('div', {
    staticClass: "topFixedWrap",
    attrs: {
      "id": "topFixed"
    }
  }, [(_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("In order to give you a better experience, please download our\n            professional APP.")]) : _vm._e(), _vm._v(" "), _c('downloadheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downLoadHeaderShow),
      expression: "downLoadHeaderShow"
    }],
    attrs: {
      "id": "headwrap"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "navBread"
  }, [_c('a', {
    staticClass: "match",
    attrs: {
      "href": "/matchs"
    }
  }, [_vm._v("Match")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/matchs/' + _vm.subtitleName,
      "id": "matchSubtitJump"
    }
  }, [_vm._v(_vm._s(_vm.subtitleName))])]), _vm._v(" "), _c('div', {
    staticClass: "bannerInformWrap clearfix",
    attrs: {
      "id": "teamWrap"
    }
  }, [_c('dl', {
    staticClass: "bannerLeft"
  }, [_c('dt', [_c('img', {
    directives: [{
      name: "team-logo",
      rawName: "v-team-logo"
    }],
    staticClass: "detailTeamLogo",
    attrs: {
      "src": _vm.getImgSrc(_vm.idData.team_A_logo),
      "alt": _vm.idData.team_A_name
    }
  })]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.idData.team_A_name))])]), _vm._v(" "), _c('div', {
    staticClass: "bannerCenterWrap"
  }, [(_vm.competeStatus === 'Played') ? _c('div', {
    staticClass: "status_ended"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v(_vm._s(_vm.idData.competition_name))]), _vm._v(" "), _c('div', {
    staticClass: "scorewrap clearfix"
  }, [_c('span', {
    staticClass: "ml15"
  }, [_vm._v(_vm._s(_vm.idData.fs_A))]), _c('b', {
    staticClass: "rowLine"
  }), _c('span', [_vm._v(_vm._s(_vm.idData.fs_B))])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.local_month_day) + " " + _vm._s(_vm.tran12(_vm.local_hour_minite)))])]) : _vm._e(), _vm._v(" "), (_vm.competeStatus === 'Playing') ? _c('div', {
    staticClass: "status_playing"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v(_vm._s(_vm.idData.competition_name))]), _vm._v(" "), _c('div', {
    staticClass: "scorewrap clearfix"
  }, [_c('span', {
    staticClass: "ml15"
  }, [_vm._v(_vm._s(_vm.idData.fs_A))]), _c('b', {
    staticClass: "rowLine"
  }), _c('span', [_vm._v(_vm._s(_vm.idData.fs_B))])]), _vm._v(" "), (_vm.idData.livingFlag) ? _c('p', {
    staticClass: "live"
  }, [_c('img', {
    staticClass: "play_arrow",
    attrs: {
      "src": require("../assets/video/video_arrow.png"),
      "alt": ""
    }
  }), _c('span', {
    staticClass: "fl"
  }, [_vm._v("LIVE IN " + _vm._s(_vm.idData.minute) + "'")])]) : _vm._e(), _vm._v(" "), (!_vm.idData.livingFlag) ? _c('p', {
    staticClass: "unlive"
  }, [_vm._v(_vm._s(_vm.idData.minute) + "'")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.competeStatus === 'Fixture') ? _c('div', {
    staticClass: "status_unstart"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v(_vm._s(_vm.idData.competition_name))]), _vm._v(" "), _c('p', {
    staticClass: "vs"
  }, [_vm._v("VS")]), _vm._v(" "), _c('div', {
    staticClass: "unstartTime clearfix"
  }, [(_vm.idData.livingFlag) ? _c('span', {
    staticClass: "unstartLive"
  }, [_vm._v("LIVE")]) : _vm._e(), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.local_month_day) + " " + _vm._s(_vm.tran12(_vm.local_hour_minite)))])])]) : _vm._e(), _vm._v(" "), (_vm.competeStatus === 'Postponed' || _vm.competeStatus === 'Cancelled' || _vm.competeStatus === 'Suspended') ? _c('div', {
    staticClass: "status_unstart"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v(_vm._s(_vm.idData.competition_name))]), _vm._v(" "), _c('p', {
    staticClass: "vs"
  }, [_vm._v("VS")]), _vm._v(" "), _c('div', {
    staticClass: "unstartTime clearfix"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.competeStatus))])])]) : _vm._e()]), _vm._v(" "), _c('dl', {
    staticClass: "bannerRight"
  }, [_c('dt', [_c('img', {
    directives: [{
      name: "team-logo",
      rawName: "v-team-logo"
    }],
    staticClass: "detailTeamLogo",
    attrs: {
      "alt": _vm.idData.team_B_name,
      "src": _vm.getImgSrc(_vm.idData.team_B_logo)
    }
  })]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.idData.team_B_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "tabWrap"
  }, [(_vm.scoreTabInfo) ? _c('span', {
    class: {
      'selected': _vm.toggleSelect === 'Score'
    },
    on: {
      "click": function($event) {
        _vm.toggle('Score')
      }
    }
  }, [_vm._v("Score")]) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      'selected': _vm.toggleSelect === 'OverView'
    },
    on: {
      "click": function($event) {
        _vm.toggle('OverView')
      }
    }
  }, [_vm._v("Overview")]), _vm._v(" "), _c('span', {
    class: {
      'selected': _vm.toggleSelect === 'Analysis'
    },
    on: {
      "click": function($event) {
        _vm.toggle('Analysis')
      }
    }
  }, [_vm._v("Analysis")]), _vm._v(" "), _c('span', {
    class: {
      'selected': _vm.toggleSelect === 'Odds'
    },
    on: {
      "click": function($event) {
        _vm.toggle('Odds')
      }
    }
  }, [_vm._v("Odds")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "contentWrap",
    attrs: {
      "id": "contentWrap"
    }
  }, [(_vm.toggleSelect === 'Score' && _vm.scoreTabInfo) ? _c('matchScore', {
    attrs: {
      "matchId": _vm.competeId,
      "scoreTabInfo": _vm.scoreTabInfo
    }
  }) : _vm._e(), _vm._v(" "), _c('match-overview', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSelect === 'OverView'),
      expression: "toggleSelect === 'OverView'"
    }],
    staticClass: "tabContent",
    attrs: {
      "matchId": _vm.competeId
    }
  }), _vm._v(" "), _c('match-analysis', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSelect === 'Analysis'),
      expression: "toggleSelect === 'Analysis'"
    }],
    staticClass: "tabContent",
    attrs: {
      "matchId": _vm.competeId
    }
  }), _vm._v(" "), _c('odds', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSelect === 'Odds'),
      expression: "toggleSelect === 'Odds'"
    }]
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcc90ab8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppMatchDetail.vue
// module id = 680
// module chunks = 2